export const TRANSLATIONS_PT_DOCUMENTS_AND_DRIVE = {
  "upload.title": "Enviar Documentos",
  "upload.drag": "Arraste e solte arquivos aqui",
  "upload.select": "Selecionar Arquivos",
  "upload.formats": "Formatos suportados: PDF, DOCX, XLSX, TXT, JSON, CSV, MD",
  "upload.processing": "Processando...",
  "upload.success": "Documento processado com sucesso",
  "upload.error": "Erro ao processar o documento",
  "upload.process_immediately": "Processar imediatamente",
  "upload.folder_name": "Nome da pasta",
  "upload.folder_placeholder": "Nome da pasta",
  "upload.tags": "Etiquetas",
  "upload.add_tag": "Etiquetas (separadas por vírgula)",
  "upload.files_to_upload": "Arquivos para enviar",
  "upload.upload_all": "Enviar tudo",
  "upload.role_id": "Função de acesso",
  "upload.role_id_help": "Opcional: restringe qual função pode ver este documento.",
  "upload.role_id_required": "Selecione uma função.",
  "upload.select_role": "Selecione uma função",
  "upload.loading_roles": "Carregando funções…",
  "upload.queued.title": "Arquivo na fila",
  "upload.queued.message": "O arquivo foi colocado na fila para processamento.",
  "upload.queued.taskId": "ID da tarefa",
  "upload.queued.checkTasks":
    "Você pode verificar o status na seção de tarefas.",
  "upload.duplicated.title": "Arquivo duplicado",
  "upload.duplicated.message":
    "Já existe um documento chamado '{{name}}'. Deseja substituí-lo?",
  "upload.duplicated.replace": "Substituir",
  "upload.success.title": "Envio bem-sucedido!",
  "upload.success.message":
    "O documento '{{name}}' foi enviado com sucesso para a pasta '{{folder}}'.",
  "documents.loading": "Carregando documentos...",
  "documents.name": "Nome",
  "documents.source": "Fonte",
  "documents.vectors": "Vetores Usados",
  "documents.date": "Data",
  "documents.delete_document_tooltip": "Excluir documento",
  "documents.delete_confirm.title": "Excluir documento",
  "documents.delete_confirm.body": "Esta ação não pode ser desfeita.",
  "documents.delete_confirm.confirm": "Excluir",
  "documents.delete_confirm.error": "Não foi possível excluir o documento.",
  "documents.download_document_tooltip": "Baixar documento",
  "documents.context.ask_only_this": "Fazer perguntas apenas sobre este documento",
  "documents.context.confirm_only_this": "Limitar o chat a este documento?",
  "documents.no_documents":
    "Não há documentos indexados. Envie alguns documentos na seção 'Enviar Documentos'.",
  "documents.refresh": "Atualizar",
  "documents.indexed_documents":
    "Lista de documentos atualmente indexados no sistema.",
  "documents.indexed_documents_title": "Documentos indexados",
  "documents.tab_overview": "Visão geral",
  "documents.tab_network": "Semântico",
  "documents.tab_details": "Detalhes",
  "documents.tab_viewer": "Visualizador",
  "documents.sidebar_types": "Tipos",
  "documents.types_distribution": "Distribuição por tipo",
  "documents.type_.pdf": "PDF",
  "documents.type_.docx": "DOCX",
  "documents.type_.txt": "TXT",
  "documents.type_.csv": "CSV",
  "documents.type_.xlsx": "XLSX",
  "documents.type_.pptx": "PPTX",
  "documents.type_.email": "E-mail",
  "documents.type_.other": "Outro",
  "documents.type_.md": "MD",
  "documents.group_today": "Hoje",
  "documents.group_last3days": "Últimos 3 dias",
  "documents.group_lastweek": "Última semana",
  "documents.group_lastmonth": "Último mês",
  "documents.group_older": "Mais antigos",
  "documents.domains": "Domínios",
  "documents.other_domains": "Outros domínios",
  "documents.documents_word": "documentos",
  "documents.search_domain": "Buscar domínio...",
  "documents.no_domain_results": "Sem resultados",
  "documents.subdomains": "Subdomínios",
  "documents.clear_filter": "Limpar filtro",
  "documents.back": "Voltar",
  "documents.domain_distribution": "Distribuição por domínio",
  "documents.subdomain_distribution":
    "Distribuição por subdomínio de {{domain}}",
  "documents.select_domain_hint":
    "Selecione um domínio para ver seus subdomínios e documentos.",
  "documents.select_subdomain_hint":
    "Selecione um subdomínio para ver seus documentos.",
  "documents.redirecting_to_details":
    "Redirecionando para detalhes do documento...",
  "documents.details_for_type": "Documentos do tipo: {{type}}",
  "documents.details_for_domain": "Documentos do domínio: {{domain}}",
  "documents.details_all": "Todos os documentos",
  "documents.group_type": "Tipo",
  "documents.group_domain": "Domínio",
  "documents.no_documents_in_group": "Nenhum documento neste grupo.",
  "documents.no_documents_found": "Nenhum documento encontrado.",
  "drive.viewer_aria_label": "Visualizador Meu Drive (somente leitura)",
  "drive.search_placeholder": "Pesquisar no Meu Drive",
  "drive.my_drive": "Meu Drive",
  "drive.filter.type.aria": "Filtrar por tipo",
  "drive.filter.type.label_all": "Tipo: Todos",
  "drive.type.folder": "Pasta",
  "drive.type.doc": "Documento",
  "drive.type.sheet": "Planilha",
  "drive.type.slide": "Apresentação",
  "drive.type.pdf": "PDF",
  "drive.type.image": "Imagem",
  "drive.type.video": "Vídeo",
  "drive.type.zip": "ZIP",
  "drive.type.other": "Outros",
  "drive.filter.owner.aria": "Filtrar por proprietário",
  "drive.filter.owner.label_all": "Proprietário: Qualquer",
  "drive.owner.you": "Você",
  "drive.owner.external": "Externo",
  "drive.owner.any": "Qualquer",
  "drive.details": "Detalhes",
  "drive.tree_aria_label": "Árvore do Meu Drive",
  "drive.breadcrumbs_aria_label": "Caminho atual",
  "drive.view.list": "Lista",
  "drive.view.grid": "Grade",
  "drive.view.list_aria": "Visualização em lista",
  "drive.view.grid_aria": "Visualização em grade",
  "drive.sort.by": "Ordenar por",
  "drive.sort.dir": "Direção da ordenação",
  "drive.sort.key.name": "Nome",
  "drive.sort.key.type": "Tipo de arquivo",
  "drive.sort.key.owner": "Proprietário",
  "drive.sort.key.modified": "Última modificação",
  "drive.sort.key.size": "Tamanho",
  "drive.dir.asc": "Asc",
  "drive.dir.desc": "Desc",
  "drive.results_showing": "Mostrando",
  "drive.table.aria_label": "Lista de itens",
  "drive.table.name": "Nome",
  "drive.table.file_type": "Tipo de arquivo",
  "drive.table.owner": "Proprietário",
  "drive.table.last_modified": "Última modificação",
  "drive.table.size": "Tamanho",
  "drive.shared": "Compartilhado",
  "drive.preview": "Pré-visualização",
  "drive.details.name": "Nome",
  "drive.details.type": "Tipo",
  "drive.details.location": "Localização",
  "drive.details.owner": "Proprietário",
  "drive.details.size": "Tamanho",
  "drive.details.created": "Criação",
  "drive.details.last_modified": "Última modificação",
  "drive.details.shared": "Compartilhado",
  "drive.yes": "Sim",
  "drive.no": "Não",
  "drive.details.permissions": "Permissões",
  "drive.permissions.read_only": "Somente leitura",
  "drive.no_selection_hint": "Selecione um item para ver seus detalhes.",
  "drive.filters_aria": "Filtros",
  "drive.hide_tree": "Ocultar arvore",
  "drive.show_tree": "Mostrar arvore",
  "drive.refreshing": "Atualizando...",
  "drive.loading_files": "Carregando arquivos...",
  "drive.preview.loading": "Carregando pre-visualizacao...",
  "drive.preview.not_available": "Pré-visualização indisponível",
  "drive.by_date": "Por data",
  "drive.status.items": "itens",
  "drive.status.items_one": "item",
  "drive.status.of": "de",
  "drive.status.selected": "selecionados",
  "drive.status.selected_one": "selecionado",
  "drive.type.email": "E-mail",
  "drive.context.move_to": "Mover para",
  "drive.context.no_move_targets": "Nenhuma pasta disponível",
  "drive.move_dialog.title": "Mover documentos",
  "drive.move_dialog.search": "Buscar pastas",
  "drive.move_dialog.items_suffix": "itens",
  "drive.move_dialog.moving": "Movendo...",
  "drive.move_dialog.error": "Nao foi possivel mover o arquivo. Verifique as permissoes ou tente novamente.",
  "drive.move_dialog.invalid_target": "Selecione uma pasta de destino valida.",
  "drive.bytes": "bytes",
  "documents.error_loading": "Erro ao carregar documentos",
  "documents.error_deleting": "Erro ao excluir documento",
  "documents.selected_type": "Tipo selecionado",
  "documents.selected_document": "Documento selecionado",
  "documents.group_lastWeek": "Última semana",
  "documents.group_lastMonth": "Último mês",
  "upload.clear_completed": "Limpar concluídos",
  "drive.contextMenu.generateSummary": "Gerar Resumo",
  "drive.generateSummary.modalTitle": "Documentos selecionados",
  "drive.generateSummary.modalHint": "Será gerado um resumo executivo destes documentos.",
  "drive.generateSummary.goToGenerate": "Ir para Gerar",
  "drive.generateSummary.noDocuments": "Selecione pelo menos um documento indexado.",
  "documents.versions.action": "Histórico de versões",
  "documents.versions.title": "Histórico de versões",
  "documents.versions.empty": "Este documento ainda não tem versões.",
  "documents.versions.error": "Não foi possível carregar o histórico de versões.",
  "documents.versions.active": "Vigente",
  "documents.versions.close": "Fechar",
};
